// Avoid collisions with App.js routes
export default {
  START: '/',
  SIGNUP_FORM: '/username-password',
  VERIFY_EMAIL: '/verify-email', // current email verification page
  VERIFY_TEXT: '/verify-text', // current text verification page
  SUCCESS: '/success',
  CONSENT: '/parental-consent',
  CONSENT_EMAIL: '/consent-email',
  TEMPLE_EXPERIENCE: '/temple-experience',
  VERIFY_CONSENT_TEXT: '/verify-consent-text',
}
